<div class="p-8">
  <div class="flex justify-between items-center">
    <h2 mat-dialog-title class="text-xl font-semibold">{{newStepName ? 'Edit Step' : 'Add Step'}}</h2>
    <button class="text-gray-500 hover:text-gray-700" (click)="cancel()"> ✕ </button>
  </div>
  <div mat-dialog-content class="mt-4">
    <input [(ngModel)]="newStepName" type="text"
      placeholder="Step name"
      class="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"/>

    <div class="grid grid-cols-5 gap-3 mb-6 mt-4">
      <div *ngFor="let icon of icons"
        class="flex items-center justify-center border rounded-lg p-2 cursor-pointer hover:bg-blue-50"
        [ngClass]="{'border-blue-500 bg-blue-100': selectedIcon === icon}"
        (click)="selectedIcon = icon">
        <div [innerHTML]="icon"></div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="flex justify-end gap-3">
    <button (click)="cancel()"
      class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100">
      Cancel
    </button>
    <button (click)="save()"
      class="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
      [disabled]="!newStepName || !selectedIcon">
      Save
    </button>
  </div>
</div>